import TermsPage from './Terms';
export default TermsPage;